import React, { useEffect } from "react";
import "../../assets/scss/_view_product.scss";
import CanvasJSReact from "../../assets/chart/canvasjs.react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBestSellingProduct } from "../../redux/actions/chartActions";
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const BestSellingProductsPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchBestSellingProduct());
  }, []);

  const bestSillingProducts = useSelector((state) => state.chart.list_selling);

  const listView = bestSillingProducts.map((item) => {
    return {
      y: item.total,
      label: item.id
    };
  });

  const options = {
    animationEnabled: true,
    exportEnabled: true,
    theme: "light1",
    title: {
      text: "Eng ko'p sotilgan mahsulotlar!"
    },
    data: [
      {
        type: "pie",
        indexLabel: "{label}: {y}%",
        startAngle: -90,
        dataPoints: listView
      }
    ]
  };

  return <CanvasJSChart options={options} />;
};

export default BestSellingProductsPage;
